import classNames from "classnames";
import { twMerge } from "tailwind-merge";

/**
 * Combines multiple class names into a single string using the `classNames` helper function
 * and then merges them using the `twMerge` function.
 *
 * @param inputs - The class names to be combined.
 * @returns The combined class names as a string.
 */
export const cn = (...inputs: Parameters<typeof classNames>) => {
  return twMerge(classNames(inputs));
};
